// extracted by mini-css-extract-plugin
export default {"contactSec":"contact_contactSec__FF-7N"};